import Nullstack from 'nullstack';
export default function IconCactus({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-cactus",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M6 9v1a3 3 0 0 0 3 3h1"
  }), "   ", Nullstack.element("path", {
    d: "M18 8v5a3 3 0 0 1 -3 3h-1"
  }), "   ", Nullstack.element("path", {
    d: "M10 21v-16a2 2 0 1 1 4 0v16"
  }), "   ", Nullstack.element("path", {
    d: "M7 21h10"
  }), " ");
}